<template>
  <div class="goodList">
    <div class="list_top">
      <div class="list_top_bg">
        <div class="list_search relative">
          <i class="f16_rem iconfont icon-search"></i>
          <input type="text" placeholder="输入货品名称">
        </div>
        <div class="list_nav">
          <ul>
            <li class="nav_active">默认</li>
            <li @click="addressPicker = true">
              地址<i class="f18_rem iconfont icon-arrowdown"></i>
              <!--icon-arrowdown-->
            </li>
            <li @click="categoryPicker = true">
              品类<i class="f18_rem iconfont icon-arrowdown"></i>
            </li>
            <li @click="price_sort = !price_sort">
              价格
              <i v-if="price_sort" class="f18_rem iconfont icon-arrowdown"></i>
              <i v-else class="f18_rem iconfont icon-arrowup"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="list_filtrate clear">
        <ul class="float-left">
          <li class="filtrate_active">促销</li>
          <li>农信优选</li>
          <li>柑橘网产品</li>
        </ul>
        <div
          class="float-left list_filtrate_more"
          @click="filtratePicker = true">更多条件</div>
      </div>
    </div>
    <div class="list_main">
      <div class="list_noGood">
        <img src="./images/noGood.png" alt="">
        <p class="gray_6">暂无货品</p>
      </div>
      <div class="list_loading">
        <van-loading type="spinner" class="t_center" vertical color="#666">加载中...</van-loading>
      </div>
      <goodTemplate1 :goodsList = goodsList />
      <goodTemplate2 :goodsList = goodsList />
      <div class="toCart">前往进货车结算</div>
    </div>
    <!--品类弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="categoryPicker" round position="bottom">
      <van-picker
        show-toolbar
        title="品类"
        :columns="columns"
        @cancel="categoryPicker = false"
        @confirm="categoryPicker = false"
      />
    </van-popup>
    <!--地区选择弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addressPicker" round position="bottom">
      <van-cascader
        v-model="address"
        title="请选择所在地区"
        :options="addressList"
        @close="addressPicker = false"
        @finish="addressPicker = false"

      />
    </van-popup>
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="filtratePicker" round position="bottom">
      <div class="filtrate_pop">
        <div class="filtrate_main bor_ddd_bottom">
          <p>按标签筛选</p>
          <ul class="clear">
            <li class="filtrate_active">农信优选</li>
            <li>促销</li>
          </ul>
        </div>
        <div class="filtrate_main bor_ddd_bottom">
          <p>按售价排序</p>
          <ul class="clear">
            <li>售价由高到底</li>
            <li>售价由低到高</li>
          </ul>
        </div>
        <div class="filtrate_main">
          <p>按销量排序</p>
          <ul class="clear">
            <li>销量由高到底</li>
            <li>销量由低到高</li>
          </ul>
        </div>
        <div class="filtrate_btn">
          <span class="gray_3 bor_ddd mar15_r">重置</span>
          <span class="white b_red">确定</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import addr from "../address.json";
import goodTemplate1 from "@/components/goodList/template1";
import goodTemplate2 from "@/components/goodList/template2";

export default {
  components: {
    goodTemplate1,
    goodTemplate2
  },

  data() {
    return {
      price_sort: true,
      filtratePicker: false,
      addressList: addr,
      address: "",
      addressPicker: false,
      categoryPicker: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华"],
      goodsList: []
    };
  },
  methods: {
    getGoodsList() {
      this.$store.dispatch("goods/goods/queryGoodsList", {
        pageNum: 1,
        typeIdVal: "",
        businessType: "",
        searchText: "测试",
        isAllSearch: "1"
      }).then((data) => {
        this.goodsList = data.list;
        this.goodsList.forEach((good) => {
          this.$set(good, "sellFactPrice", good.promotionPrice);
          this.$set(good, "sellPrice", good.marketPriceStr);
          this.$set(good, "shopName", "农信互联精品店");
        });
      });
    }
  },
  created() {
    this.getGoodsList();
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
